/**
 * Canonical numeric formatting for dashboard metrics (uk-UA grouping,
 * e.g. `12 345,68`).
 */
export const formatNumber = (num: number, decimals = 2): string =>
  new Intl.NumberFormat('uk-UA', { maximumFractionDigits: decimals }).format(num);
